import { createAction } from 'redux-actions'

export const types = {
    ASSIGN_AMBASSADOR_SETTINGS: 'ambassador/ASSIGN_AMBASSADOR_SETTINGS',
    POPULATE_AMBASSADOR_DATA: 'ambassador/POPULATE_AMBASSADOR_DATA',
    POPULATE_AMBASSADOR_CHALLENGE: 'ambassador/POPULATE_AMBASSADOR_CHALLENGE',
    POPULATE_CURRENT_INDEX: 'ambassador/POPULATE_CURRENT_INDEX',
    TOGGLE_MODAL: 'ambassador/TOGGLE_MODAL',
    POPULATE_CHALLENGE_CURRENT_INDEX: 'ambassador/POPULATE_CHALLENGE_CURRENT_INDEX',
    POPULATE_AFTER_SOCIAL_SHARE_URL: 'ambassador/POPULATE_AFTER_SOCIAL_SHARE_URL',
    POPULATE_SELECTED_CHALLENGE_INDEX: 'ambassador/POPULATE_SELECTED_CHALLENGE_INDEX',
    ON_AMBASSADOR_PROFILE: 'ambassador/ON_AMBASSADOR_PROFILE',
    POPULATE_AMBASSADOR_PROFILE: 'ambassador/POPULATE_AMBASSADOR_PROFILE'
}

export const actions = {
    assignAmbassadorSettings: createAction<AmbassadorSettingsDto>(types.ASSIGN_AMBASSADOR_SETTINGS),
    populateAmbassadorData: createAction<InitiativeDataRecord[]>(types.POPULATE_AMBASSADOR_DATA),
    populateAmbassadorChallenge: createAction<ChallengeDataRecord[]>(types.POPULATE_AMBASSADOR_CHALLENGE),
    populatCurrentIndex: createAction<number>(types.POPULATE_CURRENT_INDEX),
    toggleModal: createAction(types.TOGGLE_MODAL),
    populatChallengeCurrentIndex: createAction<number>(types.POPULATE_CHALLENGE_CURRENT_INDEX),
    populatAfterSocialShareUrl: createAction<string>(types.POPULATE_AFTER_SOCIAL_SHARE_URL),
    populatSelectedChallengeIndex: createAction<number>(types.POPULATE_SELECTED_CHALLENGE_INDEX),
    onAmbassadorProfile: createAction<boolean>(types.ON_AMBASSADOR_PROFILE),
    populateAmbassadorProfile: createAction<AmbassadorProfileRecord>(types.POPULATE_AMBASSADOR_PROFILE),
}
